var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 15.507 16.784"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1026.324 -959.907)",
    fill: "#4a4a4a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1026.324 976.691a7.754 7.754 0 017.754-7.753 7.753 7.753 0 017.753 7.753z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.877,
    cy: 3.877,
    r: 3.877,
    transform: "translate(-1022.447 959.907)"
  }))));
}
export default __webpack_public_path__ + "9ed035b55c8dd09273b948eac2243120.svg";
export { SvgUserIcon as ReactComponent };